__webpack_require__.p = "/remap-static-color/onboarding/";